module.exports = __webpack_public_path__ + "img/symphony_598_black.46a56743.jpg";